import React, { useState, useRef, useEffect } from 'react';
import { Plus } from 'lucide-react';
import EmojiPicker, { EmojiStyle, Theme } from 'emoji-picker-react';
import { cn } from '../../lib/utils';

export function MessageReactionMoreButton({ onSelect, className }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const handleEmojiClick = (emojiData) => {
    const emoji = emojiData?.emoji;
    if (emoji) onSelect?.(emoji);
    setOpen(false);
  };

  return (
    <div ref={containerRef} className="relative inline-flex items-center">
      <button
        type="button"
        title="Më shumë reagime me emoji"
        aria-label="Më shumë reagime me emoji"
        className={cn(
          'flex h-6 w-6 items-center justify-center rounded-full text-zinc-400 hover:text-zinc-950 hover:bg-zinc-100 transition p-0.5',
          open && 'bg-zinc-100 text-zinc-950',
          className
        )}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((p) => !p);
        }}
      >
        <Plus size={13} />
      </button>

      {open && (
        <div
          className="absolute bottom-8 right-0 z-[220] rounded-2xl shadow-2xl border border-zinc-200/90 bg-white overflow-hidden animate-in zoom-in-95 duration-150"
          onClick={(e) => e.stopPropagation()}
        >
          <EmojiPicker
            onEmojiClick={handleEmojiClick}
            autoFocusSearch={false}
            lazyLoadEmojis={true}
            emojiStyle={EmojiStyle.APPLE}
            theme={Theme.LIGHT}
            searchPlaceHolder="Kërko reagim me emotikon..."
            height={340}
            width={320}
          />
        </div>
      )}
    </div>
  );
}

export default MessageReactionMoreButton;
